/**
 * Joins a callout's title and body into one accessible label. A title that
 * already ends in sentence punctuation is followed by a space only, so a
 * question title is not read with a stray full stop ("Didn't get a code?.").
 */
export function calloutAccessibleLabel(title: string | undefined, body: string): string {
  if (!title) return body;
  const separator = /[.?!]$/.test(title.trimEnd()) ? ' ' : '. ';
  return `${title.trimEnd()}${separator}${body}`;
}
